const TextBox = ({text}) => {
    return(
        <div
        className="bg-[#D5D5D5] bg-opacity-50 p-2 w-full
        rounded-[10px] text-[#393939] text-center"
        >
            {text}
        </div>
    )
}
export default TextBox